"use client";

import * as React from "react";

import { cn } from "../utils/mergeClassNames";

// Timeline container component
const Timeline = React.forwardRef<
  HTMLOListElement,
  React.OlHTMLAttributes<HTMLOListElement>
>(({ className, ...props }, ref) => {
  return (
    <ol
      ref={ref}
      className={cn(
        "relative flex w-full list-none items-center justify-between overflow-x-auto px-4",
        className,
      )}
      {...props}
    />
  );
});
Timeline.displayName = "Timeline";

// Timeline group/item component
const TimelineGroup = React.forwardRef<
  HTMLLIElement,
  React.LiHTMLAttributes<HTMLLIElement>
>(({ className, ...props }, ref) => {
  return (
    <li
      ref={ref}
      className={cn(
        "relative flex min-w-fit flex-1 flex-col items-center gap-2 py-4",
        className,
      )}
      {...props}
    />
  );
});
TimelineGroup.displayName = "TimelineGroup";

// Timeline start (top content)
const TimelineStart = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn("w-full text-center", className)}
      {...props}
    />
  );
});
TimelineStart.displayName = "TimelineStart";

// Timeline middle (center icon/dot)
const TimelineMiddle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full",
        className,
      )}
      {...props}
    />
  );
});
TimelineMiddle.displayName = "TimelineMiddle";

// Timeline end (bottom content)
const TimelineEnd = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn("w-full text-center", className)}
      {...props}
    />
  );
});
TimelineEnd.displayName = "TimelineEnd";

export {
  Timeline,
  TimelineEnd,
  TimelineGroup,
  TimelineMiddle,
  TimelineStart,
};
